import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import Axios from "axios";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import { GetJobRoles } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";

const JobRolesList = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [jobRoles, setJobRoles] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(25);
    const [showIcon, setShowIcon] = useState('list');
    const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
    let Guid="";
    const guid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
    const { selectedCountry} = useCountry();
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= guid
    }
    const fetchJobRoles = async () => {
        try {
            const response = await Axios.get(`${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`);
            setJobRoles(response.data);
        } catch (error) {
            console.error("Error fetching job roles", error);
        }
    };

    useEffect(() => {
        fetchJobRoles();
    }, [selectedCountry]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(0); // Reset to the first page on new search
    };
    const handleViewToggle = (type) => {
        setViewType(type);
        setShowIcon(type)
      };
      

    // Pagination and filtering logic
    const offset = currentPage * itemsPerPage;
    const filteredJobRoles = jobRoles.filter(role => 
        role.jobRole.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const paginatedJobRoles = filteredJobRoles.slice(offset, offset + itemsPerPage);

    const handlePageClick = (e) => {
        setCurrentPage(e.selected);
    };

    return (
        <ConsultantLayout>
            <section>
                {isLoading ? (
                    <center><LoadingSpinner /></center>
                ) : (
                    <div className="container-fluid mt-4 pb-5">
                        <div className="responsive-container" style={{display: 'flex', justifyContent: 'space-between'}}>
                            <div>
                                <h2 className="" style={{ color: "#00a7ac" }}>List of Job Roles</h2>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
  {/* Toggle View Button */}
  {showIcon === 'grid' && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
      <button
        className="btn btn-primary"
        onClick={() => handleViewToggle('list')}
        style={{ backgroundColor: "#00a7ac", height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <i className="fa fa-th-list" style={{ color: '#fff', fontSize: "16px" }}></i>
      </button>
    </OverlayTrigger>
  )}

  {showIcon === 'list' && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
      <button
        className="btn btn-primary"
        onClick={() => handleViewToggle('grid')}
        style={{ backgroundColor: "#00a7ac", height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <i className="fa fa-th" style={{ color: '#fff', fontSize: "16px" }}></i>
      </button>
    </OverlayTrigger>
  )}

  {/* Search Input */}
  <input
    type="text"
    placeholder="Search by Job Role"
    className="form-control"
    value={searchTerm}
    onChange={handleSearch}
    style={{ height: "38px", flex: "1", minWidth: "200px" }} // Ensures it stretches properly
  />

  {/* Add Button */}
  <OverlayTrigger placement="bottom" overlay={<Tooltip>Add Job Role</Tooltip>}>
    <Link to="/Employer/AddJobRole">
      <button
        className="btn btn-primary"
        type="button"
        style={{ height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <i className="fa fa-plus"></i>
      </button>
    </Link>
  </OverlayTrigger>
</div>

                        </div>
                        <hr/>
                        {viewType === 'grid' ? (
                        <div className="row mt-5">
                            {paginatedJobRoles.map((item) => (
                                <div key={item.jobRoleId} className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3">
                                    <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', borderRadius: 20 }}>
                                        <div className='card-body'>
                                            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                                                <p style={{ fontSize: 14 }}><strong>Job Role:</strong> {item.jobRole}</p>
                                            </OverlayTrigger>
                                            <hr />
                                            <div className='text-center d-flex justify-content-between'>
                                                <Link to={`/Employer/EditJobRole?JobRole=${item.jobRoleId}`}>
                                                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Edit</Tooltip>)}>
                                                        <button style={{ background: "none", border: "none" }}>
                                                            <i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                                                        </button>
                                                    </OverlayTrigger>
                                                </Link>
                                                <Link to={`/Employer/GenerateAIQuestions?JobRole=${item.jobRoleId}`}>
                                                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Generate AI Questions</Tooltip>)}>
                                                        <button style={{ background: "none", border: "none" }}>
                                                            <i className="fa fa-plus" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                                                        </button>
                                                    </OverlayTrigger>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        ):
 <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
 <table className="table" 
  style={{
    minWidth: "100%",
    fontSize: "12px", // Reduced font size
    // tableLayout: "fixed",
    wordWrap: "break-word",
  }}>
   <thead>
     <tr>
       <th>Job Role</th>
       <th>Actions</th>
      
       </tr>
   </thead>
   <tbody>
     {paginatedJobRoles?.map((item, index) => (
       <tr key={index}>
         <td>{item.jobRole}</td>
         <td> <div style={{ display: "flex", gap: "5px", alignItems: "center" }}> 
                                                <Link to={`/Employer/EditJobRole?JobRole=${item.jobRoleId}`}>
                                                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Edit</Tooltip>)}>
                                                        <button style={{ background: "none", border: "none" }}>
                                                            <i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i>
                                                        </button>
                                                    </OverlayTrigger>
                                                </Link>
                                                <Link to={`/Employer/GenerateAIQuestions?JobRole=${item.jobRoleId}`}>
                                                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Generate AI Questions</Tooltip>)}>
                                                        <button style={{ background: "none", border: "none" }}>
                                                            <i className="fa fa-plus" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i>
                                                        </button>
                                                    </OverlayTrigger>
                                                </Link>
                                            </div></td>
        
        </tr>
     ))
    }
   </tbody>
 </table>
</div>}

                        {filteredJobRoles.length === 0 && (
                            <div className="pb-5 text-center">
                                <img title='No Data' alt='no-data-img' className='no-data-img' src={nodataimg} style={{ height: 370 }} />
                            </div>
                        )}
                        {filteredJobRoles.length > itemsPerPage && (
                            <ReactPaginate
                                previousLabel={"Prev"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={Math.ceil(filteredJobRoles.length / itemsPerPage)}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"}
                                disabledClassName={"disable-pagination-button"}
                            />
                        )}
                    </div>
                )}
            </section>
        </ConsultantLayout>
    );
}

export default JobRolesList;
